import api from 'shared/api';
import * as actionTypes from './actionTypes';

const getCompanyFeaturesInit = () => ({
  type: actionTypes.getCompanyFeaturesInit,
});

const getCompanyFeaturesSuccess = (res) => ({
  type: actionTypes.getCompanyFeaturesSuccess,
  features: res,
});

const getCompanyFeaturesError = (res) => ({
  type: actionTypes.getCompanyFeaturesError,
  features: res,
});

export const getCompanyFeatures = () => (dispatch) => {
  dispatch(getCompanyFeaturesInit());
  const url = '/api/v1/features/';
  return api.get(url).then(
    (res) => dispatch(getCompanyFeaturesSuccess(res.data)),
    (res) => dispatch(getCompanyFeaturesError(res.data)),
  );
};
